module.exports = __webpack_public_path__ + "img/banner.f2aa36ff.png";